import { render, staticRenderFns } from "./external-link.vue?vue&type=template&id=5eacc87e&scoped=true&"
import script from "./external-link.vue?vue&type=script&lang=js&"
export * from "./external-link.vue?vue&type=script&lang=js&"
import style0 from "./external-link.vue?vue&type=style&index=0&id=5eacc87e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eacc87e",
  null
  
)

export default component.exports